import { render, staticRenderFns } from "./DisplaySwitchButton.vue?vue&type=template&id=3ad22198&"
import script from "./DisplaySwitchButton.vue?vue&type=script&lang=js&"
export * from "./DisplaySwitchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports